import { useState, useEffect } from 'react'
import styles from './index.module.scss'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const Hero = () => {
	const [animatedText, setAnimatedText] = useState<string>('');
	const { t } = useTranslation();
	const fullText = t('index.hero.welcome');
	const navigate = useNavigate()
	

	useEffect(() => {
	let i = 0;
	let prevText = ''
	const typingEffect = setInterval(() => {
	  if (i < fullText.length) {
	  	prevText += fullText.charAt(i)
	    setAnimatedText(prevText);
	    i++;
	  } else {
	    clearInterval(typingEffect);
	  }
	}, 200);

	return () => clearInterval(typingEffect);
	}, [fullText]);


	return (
		<>
			<main>
				<section className={styles.hero}>
		          <section className={styles.hero}>
			          <h2 key={animatedText.length}>{animatedText}<span className={styles.cursor}>|</span></h2>
			          <p>{t('index.hero.second_welcome')}</p>
			          <button className={styles.ctaButton} onClick={() => navigate('/login')}>{t('index.hero.try_btn')}</button>
			        </section>
		        </section>
		          

		    </main>
		</>
	)
}


export default Hero